import dynamic from 'next/dynamic';
import { RoomImageCarouselProps } from './RoomImageCarousel.types';

export const RoomImageCarousel = dynamic<RoomImageCarouselProps>(() => import('./RoomImageCarousel'));
